import { Sentry } from "@shared/lib/sentry"

const STORAGE_KEY = "vite-chunk-reload-timestamp"
const COOLDOWN_MS = 10_000

export function isChunkLoadError(error: unknown): boolean {
  if (!(error instanceof Error)) return false
  const msg = error.message.toLowerCase()
  return (
    msg.includes("dynamically imported module") ||
    msg.includes("failed to fetch") ||
    msg.includes("loading chunk") ||
    error.name === "ChunkLoadError"
  )
}

export function handleChunkLoadError(): void {
  const stored = sessionStorage.getItem(STORAGE_KEY)
  const lastAttempt = stored ? Number(stored) : 0

  if (lastAttempt && Date.now() - lastAttempt < COOLDOWN_MS) {
    // Already reloaded recently — don't loop. Report to Sentry explicitly
    // (bypasses the ignoreErrors filter for "Failed to fetch").
    Sentry.captureMessage("Chunk load error persisted after reload", {
      level: "error",
      tags: { type: "chunk_load_error" },
    })
    return
  }

  sessionStorage.setItem(STORAGE_KEY, String(Date.now()))
  window.location.reload()
}
